<script lang="ts" setup>
import type { IMaterialSymbolOutlineProps } from '@/types/components/iconset/mso/MaterialSymbolOutline';

const props = defineProps<IMaterialSymbolOutlineProps>();
</script>

<template>
  <component :is="props.tag" class="material-symbols-outlined">
    {{ props.icon }}
  </component>
</template>
